<template>
  <div class="camp1path3" v-if="path == 3">
    <div class="path">
        
        <div :class="openedTile !== 0 ? 'step-content open' : 'step-content'">

            <a v-if="openedTile !== 0" class="back-to-list" @click="closeTile"><span>&lt;</span> Back to the list</a>

            <a v-if="(openedTile === 0)" class="close" @click="voidPath()"><span>x</span></a>

            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 7 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->
            
            <ul v-if="openedTile === 0" :class="('nav step' + step)">
                <li><a class="step1" @click="goto(1)">Setting the Table <span :class="(getProgress(1) + 'progress p'+ progress1)"></span></a></li>
                <li><a class="step2" @click="goto(2)">Governance <span :class="(getProgress(2) + 'progress p'+ progress2)"></span></a></li>
                <li><a class="step3" @click="goto(3)">Vision & Values <span :class="(getProgress(3) + 'progress p'+ progress3)"></span></a></li>
                <li><a class="step4" @click="goto(4)">Leadership <span :class="(getProgress(4) + 'progress p'+ progress4)"></span></a></li>
                <li><a class="step5" @click="goto(5)">Financing <span :class="(getProgress(5) + 'progress p'+ progress5)"></span></a></li>
                
            </ul>

            <div v-if="step == 1">
                <h1 v-if="openedTile === 0">Setting the Table</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('1.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('1.1')" class="preview" @click="showTile('1.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Legally document the business agreement and succession plan">
                            </div>
                            <div class="description">
                                <strong>Legally document the business agreement and succession plan</strong> <!--At some point, all owners will be faced with the inevitable question of transition. Early preparation for this stage can be invaluable in the case that you or your family are faced with an unforeseen tragedy. Having a plan can ease the stress and pressure on your loved ones during difficult times, or simply enhance your long-term vision for the family and the business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.1')" class="item-content">
                            
                            <h1>Succeeding in Succession</h1>

                            <iframe src="https://familyenterprise.ca/resources/ownership/succeeding-succession/?c=10" class="tut"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/Ownership-Succession-Planning.pdf'" target="_blank">Succession Planning Ownership Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous hide"></a>
                                <a class="next" @click="showTile('1.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('1.2')" class="preview" @click="showTile('1.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo117402211.jpg'" alt="Discuss plans to make sure your plan is agile, relevant and sustainable">
                            </div>
                            <div class="description">
                                <strong>Discuss plans to make sure your plan is agile, relevant and sustainable</strong> <!--In a family business, it is important to have an independent board of directors, to set up frequent family meetings, to create shared visions and to engage in formalized strategic planning. Though family business founders may be resistant to initiate various changes, many of these changes ultimately result in greater success for the family business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.2')" class="item-content">
                            <div class="col">
                                
                                <h2>Tips for Sustaining Ownership</h2>
                                <div class="res-author">David Bentall</div>
                                <div class="res-date">Published: Jan 21, 2015</div>

                                <p>Listen to David Bentall as he outlines four measures that a family business can take in order to increase their chances of being successful in succession planning. In a family business, it is important to have an independent board of directors, to set up frequent family meetings, to create shared visions and to engage in formalized strategic planning. Though family business founders may be resistant to initiate various changes, many of these changes ultimately result in greater success for the family business.</p>

                                <iframe src="https://player.vimeo.com/video/117402211?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            </div>
                            <div class="col">

                                <h2>A Next Generation Perspective on Ownership and Stewardship</h2>
                                <div class="res-author">Navin Amarasuriya</div>
                                <div class="res-date">Published: May 5, 2014</div>

                                <p>Listen to Navin Amarasuriya, Executive Director of B.P. de Silva, based in Singapore, as he speaks about communication among generations, the inclusion of in-laws and newcomers, the role of women, prosperity of the family and its enterprises, dealing with conflict and the essence of a family constitution.</p>

                                <iframe src="https://player.vimeo.com/video/84700945?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/how-to-build-your-ownership-strategy/" target="_blank">How to Build your Ownership Strategy</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.1')">Previous</a>
                                <a class="next" @click="showTile('1.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('1.3')" class="preview" @click="showTile('1.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/sucessful-succession.jpg'" alt="Is passing on the ownership desirable for you, your next gen?">
                            </div>
                            <div class="description">
                                <strong>Is passing on the ownership desirable for you, your next gen?</strong> <!--In a family business, it is important that the future generation is passionate about the business as they are often expected take on challenging roles and responsibilities.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.3')" class="item-content">
                            <div class="block">
                                <h1>Resilience - Properly Preparing the Rising Generation</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>
                                
                                <p>You’ve taken a journey with us through this decision tree and our objective is to educate you on the way.&nbsp; We’ve shared our knowledge and outlined areas to further dive deeper into so that you can be best prepared in passing the baton.</p>

                                <p>At this stage you’ve said yes to wanting to set up a Family Office. And you replied no to a series of questions. These included: No to Are you including family members in the structure, No to Do you have the right professionals in place, and No to Are you ready to hire, reward and retain the best people.</p>

                                <p>Now, you may have all kinds of reasons for having answered no to these questions.&nbsp; Too often it is because we have not taken the time to plan.&nbsp;We don’t take the time to ask some simple questions and map out the road ahead. And this is where resilience plays its role.</p>

                                <p>Resilience in the capacity to recover quickly from difficulties.&nbsp; Psychologists define resilience as the process of adapting well in the face of adversity, trauma, tragedy, threats, or significant sources of stress-such as family and relationship problems, serious health problems, or workplace and financial stressors.&nbsp; Do you give yourself and/or your children enough opportunity to test their own resilience?</p>

                                <p>According to Dr. Ginsburg, a child pediatrician and human development expert, there are 7 integral and interrelated components that make up being resilient:</p>

                                <ul>
                                    <li>Competence</li>
                                    <li>Confidence</li>
                                    <li>Connection</li>
                                    <li>Character</li>
                                    <li>Contribution</li>
                                    <li>Coping</li>
                                    <li>Control</li>
                                </ul>

                                <p>How many of these components have you helped nurture in yourself?&nbsp; How many have you nurtured into your rising generation?</p>

                                <p>I find it very unfortunate when I come across families who have children well into their 50s who still feel they have no control over their life.&nbsp; There is the constant dangling of the proverbial carrot “DO as I say or else.”&nbsp; Or I hear the following generation comment “Dad still controls everything and will continue to control from the grave.”&nbsp; This is not where you want to be if you are serious about being a family enterprise and setting up a successful continuity plan.&nbsp;</p>

                                <p>It is time to buckle down and put pen to paper – what is it all for?&nbsp; Past the business, the wealth accumulated, what do you see for your family?&nbsp; Can you answer these questions in 7 words or less?&nbsp; Truly be clear on what you want for your loved ones and share that vision? The fact is that there is no correlation between successful succession planning and successful succession.</p>


                                <figure class="aligncenter size-full is-resized"><img :src="baseurl + 'assets/images/sucessful-succession.png'" alt="Sucessful Succession" width="664" height="498"></figure>

                                <p>You can have all your advisors: financial managers, lawyers, estate plan specialists, tax specialists, insurance specialists, accountant, banker and business strategist, with their “I’s” dotted and “T’s” crossed but that only accounts for 15% of a family enterprises success.&nbsp; What about the other 85%?</p>

                                <p>Taking the time to properly prepare the rising generation, giving them a chance to practice resilience, communicating your vision and outlook for the family’s future.&nbsp; What are their passions and interests? What skillsets do they have, and which ones do they need to develop more? How do they learn and how can you engage them in the type of learning that is best for them? Continuity planning is essential, and a parallel process of preparing your next generation is as important to the family legacy. This is where 85% of a family enterprise’s success lies.</p>

                                <p>This can all begin with seeking the guidance of a skilled FEA to help build a resilient Family Office.&nbsp; It might start by focusing on the Business Circle, taking the time to build an effective business plan, with a clear mission vision, a profit and loss forecast to support the investment in manpower needed to staff it up, and the projections of revenue to pay for the upkeep.&nbsp; This can then be presented to the family circle members to get them excited to support the plan.</p>

                                <p>And if you are aiming to be a trans-generational family you will have to pass on the entrepreneurial mindset and capabilities to your next generation.&nbsp; You will have to encourage new streams of wealth across many generations. And you have to sustain the family as the trans-generational engine.&nbsp; Give your rising generation the chance to be resilient.&nbsp; This takes work and is much harder than building your business. If you have the will there is definitely a way.</p>

                                <p><strong>Decision Tree Question: Seek FEA Guidance to Build a Resilient Family Office</strong></p>
  
  
                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/path-for-the-rising-generation/" target="_blank">Path for the Rising Generation</a></li>
                                        <li class="podcast"><a href="https://familyenterprise.ca/resource/inheritance-styles-a-road-map-for-the-rising-generation/" target="_blank">Inheritance Styles: A Road Map for the Rising Generation</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('1.2')">Previous</a>
                                    <a class="next" @click="showTile('1.4')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('1.4')" class="preview" @click="showTile('1.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Appoint a trusted advisor/facilitator">
                            </div>
                            <div class="description">
                                <strong>Appoint a trusted advisor/facilitator</strong> <!--A FEA has gone through vigorous training and has many tools to share with business families. In my opinion, the 2 greatest advantages of hiring an FEA is that 1) they have been trained to check in on their biases and have the added edge to be able to ask some sensitive questions to take a family further down a path of successful continuity planning and 2) they understand the advantage of the multidisciplinary team approach, opening doors to invite other advisors as needed to best serve the client.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.4')" class="item-content">
                            
                            <div class="block">
                                <h1>Advantages of Engaging a Family Enterprise Advisor (FEA)</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>  
                                
                                <p>Article 36</p>

                                <p>A FEA has gone through vigorous training and has many tools to share with business families.&nbsp; In my opinion, the 2 greatest advantages of hiring an FEA is that 1) they have been trained to check in on their biases and have the added edge to be able to ask some sensitive questions to take a family further down a path of successful continuity planning and 2) they understand the advantage of the multidisciplinary team approach, opening doors to invite other advisors as needed to best serve the client.</p>

                                <p>The complexities a family enterprise faces are numerous.&nbsp; It’s hard enough to understand just one discipline of the family business. &nbsp;Intertwine that with family dynamics, future ownership, legal structures, estate planning, heirloom assets and all that makes up a family enterprise and no doubt there is confusion.&nbsp;No doubt many areas are not looked at. No doubt it is hard and why so many families give up and don’t even venture down this road.</p>

                                <p>I encourage you to be empowered by your vision and what you want to achieve as a family.&nbsp; When a family finds the way to come together and co-own what an entrepreneurial elder worked so well at building up, the harmony and love that brings a family together grows exponentially.&nbsp; I will repeat, this road of co-ownership is not for all families, it is very difficult and heart-wrenching to deal with family dynamics and the conflicts that for some seem so irrational.&nbsp; Do you have the strength to endure the rocky road ahead, to have intentional conversations that move you forward one obstacle at a time?</p>

                                <p>Having a trusted advisor, a skilled <a href="https://familyenterprise.ca/fea-directory/" target="_blank">Family Enterprise Advisor,</a> who understands all the moving parts, who has been educated on seeing the family business as a paradox and has the tools to put the family client first and educate them as their journey together up the road of continuity planning, brings many advantages.</p>

                                <p>Some of these advantages are:</p>

                                <ol type="1">
                                    <li>An FEA better understands the complexities and challenges of a family enterprise</li>
                                    <li>An FEA takes a whole system approach</li>
                                    <li>An FEA has many strategies and tools to help families navigate the intricate and difficult issues they face</li>
                                    <li>An FEA understands the difference between content consulting and process consulting and that it is not about the end result but more so the process a family client experiences and provides a clear structure</li>
                                    <li>An FEA has the ability for strategic advising and their technical skills are augmented to include human and social considerations related to family enterprises</li>
                                    <li>An FEA brings forward the element of a multi-disciplinary team approach. To network and work with other family business advisors from a variety of different disciplines</li>
                                    <li>An FEA focuses on more than financial wealth and understands the concept of total wealth being more than the family’s financial assets. Total wealth includes Human capital which includes the relationships of the family and the talents of the next generation.&nbsp; It includes Intellectual capital which encompasses each individual’s knowledge, education, and life experiences.&nbsp; It includes Social capital, the networks, connections and the people you know. And it includes Spiritual capital which encompasses the family’s values, intentions, and legacy it wants to be remembered for.</li>
                                </ol>

                                <p>Hiring a skilled FEA brings many advantages. Get all your family members on the same team and begin your training to this relay race. With the right team and determination, you can successfully pass this baton and succeed to being a successful multigenerational family enterprise.</p>

                                <p><strong>Decision Tree Question: Engage a FEA</strong></p>
  
                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/feas-role-as-the-family-enterprise-advisor/" target="_blank">FEAs Role as The Family Enterprise Advisor</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('1.3')">Previous</a>
                                    <a class="next" @click="showTile('1.5')">Next</a>
                                </div>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('1.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('1.5')" class="preview" @click="showTile('1.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/ownership-stages.jpg'" alt="Founder to siblings">
                            </div>
                            <div class="description">
                                <strong>Founder to siblings</strong> <!--Explore this dynamic model to gain a deeper appreciation for the different roles played by and owner vs. a manager. The main difference is working ON vs. working IN the family business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.5')" class="item-content">
                            
                            <three-circle-model model="c1p3s1t5" />

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a href="https://www2.deloitte.com/content/dam/Deloitte/ca/Documents/tax/ca-tax-en-Planning-beyond-horizon-Oct-2021-AODA.pdf" target="_blank">Planning beyond the horizon A multi-generational outlook</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.4')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('2.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                   
                </ul>
            </div>









            <div v-if="step == 2">
                <h1 v-if="openedTile === 0">Clarifying the Goals and Priorities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('2.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('2.1')" class="preview" @click="showTile('2.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Where will key ownerhsip issues be discussed with all owners?">
                            </div>
                            <div class="description">
                                <strong>Where will key ownerhsip issues be discussed with all owners?</strong> <!--Shareholder agreements are critical. These company playbooks ensure all shareholders are treated fairly. They lay out how a company will be operated and managed, spell out the rights of various shareholders and establish guidelines for who makes company decisions.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.1')" class="item-content">
                            <div class="block">
                                <h1>Family Shareholders’ Assembly</h1> 

                                <iframe :src="baseurl + 'assets/pdf/ownership/Family-Shareholders-Assembly.pdf'" class="pdf"></iframe>
                                
                            </div>  

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/Family-Shareholders-Assembly.pdf'" target="_blank">Family Shareholders’ Assembly Template</a></li>

                                    <li class="link"><a href="https://canadianfamilyoffices.com/family-business/shareholder-agreements-so-critical-yet-often-a-family-hot-potato" target="_blank">Shareholder agreements: So critical, yet often a family 'hot potato'</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('1.5')">Previous</a>
                                <a class="next" @click="showTile('2.2')">Next</a>
                            </div>
  
                        </div>
                    </li>
                    <li :class="statusClass('2.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('2.2')" class="preview" @click="showTile('2.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Develop a junior Board for NxG introduction to governance">
                            </div>
                            <div class="description">
                                <strong>Develop a junior Board for NxG introduction to governance</strong> <!--Listen to this webinar where FEA Wendy Sage-Hayward joins Gaia Marchisio in conversation to discuss their new book, Own it! How to Develop Family Enterprise Owners Mindset at Every Age.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.2')" class="item-content">
                            
                            <h1>Own it! How to Develop Family Enterprise Ownership Skills at Every Age</h1>

                            <p><strong>2021 Webinar Series</strong></p>
                            <p><strong>Hosts:</strong> Russel Baskin, National Director, Education and Programming, Family Enterprise Canada</p>

                            <p><strong>Speakers:</strong> Wendy Sage-Hayward, Senior Consultant, Family Business Consulting Group and Gaia Marchisio, Executive Director, Cox Family Enterprise Centre at Kennesaw State University, Aronoff Professor of Family Business</p>

                            <p>Wendy Sage-Hayward joins Gaia Marchisio in conversation to discuss their new book, Own it! How to Develop Family Enterprise Owners Mindset at Every Age.</p>

                            <iframe src="https://player.vimeo.com/video/554889898" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a href="https://familyenterprise.ca/wp-content/uploads/2021/05/2105-OWN-IT-Webinar-FINAL-May-2021_Approved.pdf" target="_blank">Download the slides</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.1')">Previous</a>
                                <a class="next" @click="showTile('2.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('2.3')" class="preview" @click="showTile('2.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Establish a process to settle important ownerhsip issues">
                            </div>
                            <div class="description">
                                <strong>Establish a process to settle important ownerhsip issues</strong> <!--Conflict and disputes are normal and should be expected. However, it's how you deal with these conflicts that will test your governance resilience and dictate how successful you will be as a united ownership group-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.3')" class="item-content">
                            <h1>Conflict Management Committee</h1> 

                            <iframe :src="baseurl + 'assets/pdf/ownership/Conflict-Management Committee.pdf'" class="pdf"></iframe> 

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/Conflict-Management Committee.pdf'" target="_blank">Conflict Management Committee - Template</a></li>
                                    
                                    <li class="video"><a href="https://familyenterprise.ca/resource/open-communication-is-key-to-prevent-and-resolve-conflict/" target="_blank">Open Communication is Key to Prevent and Resolve Conflict</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.2')">Previous</a>
                                <a class="next" @click="showTile('2.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('2.4')" class="preview" @click="showTile('2.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Maintain information links with Board members">
                            </div>
                            <div class="description">
                                <strong>Maintain information links with Board members</strong> <!--Explore this infographic on how to reinforce stewardship in your entrepreneurial family in order to drive performance before attempting to strcture this Steward role in your ownership group.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.4')" class="item-content">
                            <h1>The Steward</h1> 

                            <iframe :src="baseurl + 'assets/pdf/ownership/The-Steward.pdf'" class="pdf"></iframe> 

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/The-Steward.pdf'" target="_blank">The Steward - Template</a></li>
                            
                                    <li class="link"><a href="https://familyenterprise.ca/resource/family-business-stewardship-driving-performance/" target="_blank">Family Business Stewardship – Driving Performance</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.3')">Previous</a>
                                <a class="next" @click="showTile('2.5')">Next</a>
                            </div>

                        </div>
                        
                    </li>
                    <li :class="statusClass('2.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('2.5')" class="preview" @click="showTile('2.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo133568763.jpg'" alt="Develop mechanisms to maintain contact with departing owners">
                            </div>
                            <div class="description">
                                <strong>Develop mechanisms to maintain contact with departing owners</strong> <!--Listen to a family business member discuss the governance structures that will enable the business to move from the founder to the next generation.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.5')" class="item-content">
                            
                            <h1>Enabling Communication Through Governance Structures</h1> 
                            <div class="res-date">Published: Jul 15, 2015</div>
                            <p>Listen to Yuelin Yang discuss the governance structures that will enable the business to move from the founder to the next generation.</p>

                            <iframe src="https://player.vimeo.com/video/133568763?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                            <!--div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a :href="baseurl + '#'" target="_blank"></a></li>
                                </ul>
                            </div-->

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.4')">Previous</a>
                                <a class="next" @click="showTile('2.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('2.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('2.6')" class="preview" @click="showTile('2.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Who is in the owners group?">
                            </div>
                            <div class="description">
                                <strong>Who is in the owners group?</strong> <!--Before completing the template work, listen to this webinar that explores how owners and future owners of a family business should get started with ownership meetings. We looked to clarify what needs to be on the agenda and who needs to be present in these meetings to ensure this is well covered and attended to in your family enterprise.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.6')" class="item-content">
                            
                           <h1>What Do We Own and Who Owns It?</h1>

                           <iframe :src="baseurl + 'assets/pdf/ownership/What-Do-We-Own-and-Who Own-It.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/What-Do-We-Own-and-Who Own-It.pdf'" target="_blank">What Do We Own and Who Owns It? - PDF Template</a></li>
                                    
                                    <li class="video"><a href="https://familyenterprise.ca/resource/starting-an-ownership-council/" target="_blank">Starting an Ownership Council</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('3.1')">Next</a>
                            </div>

                        </div>
                        
                    </li>
                </ul>
            </div>




            <div v-if="step == 3">
                <h1 v-if="openedTile === 0">Reviewing Owner's Strategy</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('3.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('3.1')" class="preview" @click="showTile('3.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/ownership3.jpg'" alt="Align family, business and ownership vision, mission,& values">
                            </div>
                            <div class="description">
                                <strong>Align family, business and ownership vision, mission,& values</strong> <!--Take some time to gain a deeper underestanding of how values impact decision-making, illustrate the benefits of having shared values in the ownership group and learn how to align business practices with those shared values.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.1')" class="item-content">
                            <h1>Align family, business and ownership vision, mission,& values</h1>
                            <iframe src="https://familyenterprise.ca/resources/ownership/views-values/?c=10" class="tut"></iframe>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('2.6')">Previous</a>
                                <a class="next" @click="showTile('3.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('3.2')" class="preview" @click="showTile('3.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Develop a learning agenda and ensure learning is funded through the owner's budget">
                            </div>
                            <div class="description">
                                <strong>Develop a learning agenda and ensure learning is funded through the owner's budget</strong> <!--What are your plans to become a learning organization? While you read the articles and watch the video, begin to reflect on the type of leanring organization you want to be-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.2')" class="item-content">
                            
                            <div class="col">
                                <h2>Growing Your Family’s Human Capital – 10 Lessons from the Emergence of the Chief Learning Officer</h2>

                                <a :href="baseurl + 'assets/pdf/ownership/Article-Growing-Your-Familys-Human-Capital.pdf'" target="_blank" class="play-link">
                                <span>Click here to read more</span><img :src="baseurl + 'assets/images/camp1-3-3.2-article1.jpg'" alt="Article 1"></a>
                            </div>

                            <div class="col">
                                <h2>Preparing Heirs Through Experiential Learning<br />&nbsp;</h2>

                                <a :href="baseurl + 'assets/pdf/ownership/Article-Preparing-Heirs.pdf'" target="_blank" class="play-link">
                                <span>Click here to read more</span><img :src="baseurl + 'assets/images/camp1-3-3.2-article2.jpg'" alt="Article 2"></a>
                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/family-learning/" target="_blank">Family Learning</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.1')">Previous</a>
                                <a class="next" @click="showTile('3.3')">Next</a>
                            </div>

                        </div>
                    </li>
                    <li :class="statusClass('3.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('3.3')" class="preview" @click="showTile('3.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo480415493.jpg'" alt="Create a link between the family purpose and owners vision">
                            </div>
                            <div class="description">
                                <strong>Create a link between the family purpose and owners vision</strong> <!--Many family businesses lack a sense of shared purpose. Family members too often avoid tough issues by avoiding meaningful conversations. Left unaddressed, these tensions increase distrust in families and obstruct performance in their organizations. But with the right skills, high-trust relationships and structures in place, such breakdowns can be overcome.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.3')" class="item-content">
                            <div class="block">

                                <h1>Family Purpose (FFLA)</h1>
                                <div class="res-author">Kendall Cotton Bronk</div>
                                <div class="res-date">Published: Nov 19, 2020</div>
                                
                                <iframe src="https://player.vimeo.com/video/480415493?h=f1f2f0f884&amp;dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="link"><a href="https://bg.hbr.org/2020/05/4-tensions-in-family-businesses-and-how-to-work-through-them" target="_blank">4 Tensions in Family Businesses — and How to Work Through Them</a></li>
                                        <li class="podcast"><a href="https://familyenterprise.ca/resource/what-is-purposeful-planning-and-how-can-it-benefit-our-family-clients/" target="_blank">What is Purposeful Planning and How Can it Benefit Our Family Clients?</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('3.2')">Previous</a>
                                    <a class="next" @click="nextStep(); showTile('4.1')">Next</a>
                                </div>

                            </div>
                        </div>
                    </li>
                    <!--li :class="statusClass('3.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('3.4')" class="preview" @click="showTile('3.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Introduction to Family Vision">
                            </div>
                            <div class="description">
                                <strong>Introduction to Family Vision</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('3.4')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.3')">Previous</a>
                                <a class="next" @click="showTile('3.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('3.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('3.5')" class="preview" @click="showTile('3.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Create plan to integrate/refresh family values & vision & articluate it to all stakeholders">
                            </div>
                            <div class="description">
                                <strong>Create plan to integrate/refresh family values & vision & articluate it to all stakeholders</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('3.5')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.4')">Previous</a>
                                <a class="next" @click="showTile('3.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('3.6')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('3.6')" class="preview" @click="showTile('3.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Designation of a family leader">
                            </div>
                            <div class="description">
                                <strong>Designation of a family leader</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('3.6')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.5')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('4.1')">Next</a>
                            </div>
                        </div>
                        
                    </li-->
                </ul>
            </div>



            <div v-if="step == 4">
                <h1 v-if="openedTile === 0">Planning the Transition of Responsibilities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('4.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('4.1')" class="preview" @click="showTile('4.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Facilitate ownership training sessions for successors">
                            </div>
                            <div class="description">
                                <strong>Facilitate ownership training sessions for successors</strong> <!--We are not born as good owners; it requires careful training and skills development to become one. Learn how to develop an owners mindset in your successor generation-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.1')" class="item-content">
                            <h1>Facilitate ownership training sessions for successors</h1>

                            <iframe src="https://familyenterprise.ca/resources/tut3/" class="tut"></iframe>
                            

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="podcast"><a href="https://familyenterprise.ca/resource/how-to-develop-an-owners-mindset-at-every-age/" target="_blank">How to Develop an Owner’s Mindset at Every Age</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('3.3')">Previous</a>
                                <a class="next" @click="showTile('4.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('4.2')" class="preview" @click="showTile('4.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo246001750.jpg'" alt="New Era of Ownership">
                            </div>
                            <div class="description">
                                <strong>New Era of Ownership</strong> <!--The expectations and role of a leader is constantly evolving. Furthermore, some leaders are best suited to lead in certain environments and not others. Expolore how leadership looks in your family ownership group-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.2')" class="item-content">
                            
                            <div class="col">
                                <h2>Preparing the Rising Generation for Leadership Roles</h2>
                                <iframe src="https://player.vimeo.com/video/246001750?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>
                            <div class="col">
                                <h2>The Changing Face of Leadership in Business Families</h2>
                                <iframe src="https://player.vimeo.com/video/246000751?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/aaron-gillespie-ownership-transition-and-community-connection/" target="_blank">Aaron Gillespie: Ownership Transition and Community Connection</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.1')">Previous</a>
                                <a class="next" @click="showTile('4.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('4.3')" class="preview" @click="showTile('4.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo133580925.jpg'" alt="Keep stakeholders in the loop (elders, spouses, successors, professional management and trustees)">
                            </div>
                            <div class="description">
                                <strong>Keep stakeholders in the loop (elders, spouses, successors, professional management and trustees)</strong> <!--Frequent communication, in any business, is essential in the avoidance and resolution of conflict. When communicating, it is equally important to discuss both conflicts as well as successes of the business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.3')" class="item-content">
                            <h1>Communicating Succession Plans</h1>
                            <div class="res-author">Kong Eng Huat</div>
                            <div class="res-date">Published: Jul 15, 2015</div>

                            <p>Kong Eng Huat talks about the importance of communication about succession and the value of including outside facilitators.</p>

                            <iframe src="https://player.vimeo.com/video/133580925?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/complexities-of-communication-owners-founders-leaders/" target="_blank">Complexities of Communication – Owners, Founders, Leaders</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.2')">Previous</a>
                                <a class="next" @click="showTile('4.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('4.4')" class="preview" @click="showTile('4.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Identify the person repsonsible for overseeing the ownerhsip succession process">
                            </div>
                            <div class="description">
                                <strong>Identify the person repsonsible for overseeing the ownerhsip succession process</strong> <!--Use this template to begin building your ownership planning process and identify who will be repsonsible for overseeing this process-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.4')" class="item-content">
                            <h1>Ownership Planning Process</h1>

                            <iframe :src="baseurl + 'assets/pdf/ownership/Ownership-Planning-Process.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/Ownership-Planning-Process.pdf'" target="_blank">Ownership Planning Process - Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.3')">Previous</a>
                                <a class="next" @click="showTile('4.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('4.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('4.5')" class="preview" @click="showTile('4.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Selecting an owner mentor for NxG">
                            </div>
                            <div class="description">
                                <strong>Selecting an owner mentor for NxG</strong> <!--It has been proven time and time again that one of the best practices of readying your next generation of owners is through mentorship. Begin plotting your strategy to ensure your next generation has the right mentors in place.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.5')" class="item-content">
                            <h1>Shareholders Mentors</h1>

                            <iframe :src="baseurl + 'assets/pdf/ownership/Shareholders-Mentors.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/Shareholders-Mentors.pdf'" target="_blank">Shareholdes Mentors - Template</a></li>
                                    
                                    <li class="video"><a href="https://familyenterprise.ca/resource/mentoring-and-coaching-the-rising-generation/" target="_blank">Mentoring and Coaching the Rising Generation</a></li>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/the-importance-of-mentors-for-next-generation-leaders/" target="_blank">The Importance of Mentors for Next Generation Leaders</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.4')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('5.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>






            <div v-if="step == 5">
                <h1 v-if="openedTile === 0">Transitioning Ownerhsip Value</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('5.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('5.1')" class="preview" @click="showTile('5.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Establish clear and defined ownerhsip rules ">
                            </div>
                            <div class="description">
                                <strong>Establish clear and defined ownerhsip rules </strong> <!--Listen to the Ten Domains of Family Wealth and consider the importance of having knowledge, skills and the ability to learn to play well with others.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.1')" class="item-content">
                            <h1>10 Domains of Family Wealth</h1>
                            
                            <p><strong>Let’s Talk Family Enterprise Podcast Episode #29</strong></p>
                            <p>Host: Steve Legler<br />Guests: Dr. Jim Grubman</p>

                            <p>Host Steve Legler speaks with Dr. Jim Grubman about everything from “Wealth 3.0” and the Ten Domains of Family Wealth to the importance of having knowledge, skills and the ability to learn to play well with others.</p>

                            <audio controls="" src="https://traffic.libsyn.com/secure/familyenterpriseadvisors/FEX_029.mp3"></audio>

                           

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('4.5')">Previous</a>
                                <a class="next" @click="showTile('5.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('5.2')" class="preview" @click="showTile('5.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Understand your financially owned, ownership assets and devise a plan, with an advisor, for the trasnitioning of them	">
                            </div>
                            <div class="description">
                                <strong>Understand your financially owned, ownership assets and devise a plan, with an advisor, for the trasnitioning of them</strong> <!--How do you own your business? Use this template of questions to begin fully understanding what you own, how you own it and what it's worth-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.2')" class="item-content">
                            <h1>How you Own and What it's Worth</h1>

                            <iframe :src="baseurl + 'assets/pdf/ownership/How-you-Own-and-What -its-Worth.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="podcast"><a :href="baseurl + 'assets/pdf/ownership/How-you-Own-and-What -its-Worth.pdf'" target="_blank">How you Own and What it's Worth - Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.1')">Previous</a>
                                <a class="next" @click="showTile('5.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    
                    <li :class="statusClass('5.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('5.3')" class="preview" @click="showTile('5.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo149885329.jpg'" alt="Fair vs equal">
                            </div>
                            <div class="description">
                                <strong>Fair vs equal</strong> <!--In a family business, it is important to encourage all members to contribute to decisions by voicing their opinions. As family members feel they are valuable to the business, they will be more motivated to work toward its success.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.3')" class="item-content">
                            <h1>Is it Better to be Equal or to be Fair?</h1>
                            <div class="res-author">Raphael Amit</div>
                            <div class="res-date">Published: Jan 18, 2016</div>  
                            
                            <p>Raphael Amit talks about fairness in relation to both process and result.</p>

                            <iframe src="https://player.vimeo.com/video/149885329?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/developing-family-ownership/" target="_blank">Developing Family Ownership</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.2')">Previous</a>
                                <a class="next" @click="showTile('5.4')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('5.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('5.4')" class="preview" @click="showTile('5.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="In the event…">
                            </div>
                            <div class="description">
                                <strong>In the event…</strong> <!--You never expect something bad, or unexpected, to happen, but planning for this is still an important step in succession planning. Don’t dwell on it for too long, but take some steps towards planning for the unexpected-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.4')" class="item-content">
                            <h1>What Happens if There is an Unexpected Tragedy?</h1> 

                            <iframe :src="baseurl + 'assets/pdf/ownership/What-Happens-if-There-is-an-Unexpected-Tragedy.pdf'" class="pdf"></iframe> 

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/What-Happens-if-There-is-an-Unexpected-Tragedy.pdf'" target="_blank">What Happens if There is an Unexpected Tragedy? - Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.3')">Previous</a>
                                <a class="next" @click="showTile('5.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
               
                    <li :class="statusClass('5.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.5')" class="preview" @click="showTile('5.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/Managing-Risk-Image-Balance.jpg'" alt="Explore financial risk/reward levels">
                            </div>
                            <div class="description">
                                <strong>Explore financial risk/reward levels</strong> <!--Read this case story of the Gilbert family and refelct on your risk/reward levels-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.5')" class="item-content">
                            <div class="block">

                                <h1>Managing Risk in the Family Enterprise</h1>
                                <div class="res-author">Wendy Sage-Hayward, MA, FEA</div>
                                <div class="res-date">Published: Jun 17, 2021</div>  
    
                                <h2>A&nbsp;<em>Family Focus</em>&nbsp;story</h2>

                                <img :src="baseurl + 'assets/images/Managing-Risk-Image-Balance.jpg'" alt="Managing Risk in the Family Enterprise" style="float: left; margin-right: 30px; margin-bottom: 30px;" width="450" height="345">
                                
                                <p>The Gilberts faced an opportunity and a challenge. The family, based in the Canada’s Pacific Northwest region, are second-generation winemakers. Deborah and Ron, children of the founder, along with their spouses, have operated Over the Hill Vineyard and Winery for the past three decades. They produce award-winning wines, including several vintages of chardonnay and pinot noir, and have a growing customer base nationwide through their wine club and social media campaign.</p>

                                <p>In 2019, with strong revenue and cash reserves, the Gilberts saw an opportunity to significantly expand their operations. The family currently owned 25 acres of land, a 12,000ft² winery facility and a chic bistro featuring gourmet food and a tasting room. For years they bought additional varietals from area growers to increase their production to 10,000 cases; however, the quality of these outside grapes was inconsistent. As their sales and reputation grew, the Gilberts wanted to increase production capacity while remaining a top-quality wine producer.</p>

                                <p>Moreover, the family had heard a nearby vineyard was up for sale. At a full 80 acres, it was significantly larger than their current vineyard almost exactly the size they wanted. However, there were two significant obstacles. First, the vineyard had been neglected for almost a decade due to the current owners’ chronic health issues. The vines were feral and would require considerable investment of time and money to restore. Additionally, it was located on an island off the local coast, which meant ideal growing conditions for multiple varietals, but further challenges related to transportation, labor and community relations. For example, the island’s permanent resident community was wary of outsiders and had shown only limited support for economic development activities, as they wished to keep island life simple. All of this meant that the Gilberts faced both the typical risks of expansion — such as capital and infrastructure risk — as well as more unique risks related to this specific opportunity.</p>

                                <p>In the Gilbert family, Deborah and her husband were more willing to take greater risks, due to their focus on the potential gains rather than potential consequences. So, their individual risk appetites were higher than average, especially for family enterprise members. Ron and his wife, in contrast, were more risk-averse, wary of making large moves, including those related to expansion. Unlike Deborah, whose children were still young, Ron had adult children, and he and his wife were looking forward to a more relaxed life including regular vacations and retirement on the horizon — so they were more cautious with finances. Indeed, Ron was more conservative in general and had questioned some of his sister’s financial and other judgement calls over the past five years. Thus, the family collectively had a mixed approach to risk, with large variations in risk-related preferences.</p>

                                <p>Not surprisingly, this family culture led to challenges and, sometimes, outright clashes around decision-making, with the couples reliably falling on different sides of the risk continuum: Deborah and her husband pushed for pursuit of the island vineyard acquisition, while Ron and his wife were much more cautious about wanting to go ahead with the expansion.</p>

                                <p>The Gilbert’s decided to take a strategic approach to risk-management in order to better manage the potential negative business impacts. They took a simple and pragmatic approach utilizing well-established risk management principles and steps (see model below, <em>source: Sage-Hayward, W. (2021). The Lifecycle of a Family Business</em>).</p>

                                <figure class="wp-block-image size-large is-resized"><img loading="lazy" :src="baseurl + 'assets/images/strategic-risk-approach.png'" alt="Strategic Risk Approach" class="wp-image-764062" width="874" height="647"></figure>

                                <p>Wisely, the Gilberts followed the risk-management steps here to assess and address the risks of moving forward with acquisition of the island vineyard. First, they spent significant time assessing risks part of the family enterprise system. In the business circle, for example, they recognized the large potential costs of logistics, including labor and transportation. The vineyard’s housing for laborers was dilapidated and would require significant investment to be habitable. Similarly, transportation of supplies to the island was costly. They accounted for these costs in their business plan to provide a more realistic forecast of the capital required to finance the new operation. They also understood the need to maintain strong relationships with the island community and local government, as related to stakeholder relations risk. Moreover, dealing with the risks the new vineyard posed could distract or take resources from the current operations, compromising performance.</p>

                                <p>In the family domain, Ron was particularly concerned that the financial stress of expansion might disrupt or erode his relationship with his sister. Deborah worried she might resent Ron if he stood in the way of the acquisition, closing off a potentially valuable opportunity for the business. They and their spouses recognized the couples had divergent visions: while Ron wanted a more manageable business, his sister wanted to create a larger business legacy — and wealth — for future generations.</p>

                                <p>On the ownership dimension, perceptions of risk were related closely to the “harvest versus growth” challenge family owners face. Ron and his wife were much more harvest-focused than his sister and her husband. Ron was eager to preserve large dividends for family members, to secure his vision of a more relaxed empty-nesting stage, including the ability to take regular vacations. Deborah was more willing to re-invest profits in the business, rather take distributions. Both recognized the risk that came from working with untested grapes — if product quality became an issue, it could affect the brand, profits, dividends and family reputation significantly, which none of them wanted.</p>

                                <p>The couples discussed these issues at length in the context of their individual and collective risk appetites and attitudes. The conversations themselves were of great value, as the four owners had never sat down together to discuss risk so thoroughly and openly. Armed with greater shared understanding of their risk-related perceptions and concerns, they ultimately instituted several measures of risk-mitigation.</p>

                                <p>In this way, the Gilbert’s’ systematic approach to risk-management surfaced their preferences and concerns in a safe environment and enabled them to reach an integrative solution that addressed risk in all three family enterprise domains and move forward with their expansion plans. They also agreed to monitor risk carefully, have regular risk-related discussions and revise their plan as needed going forward.</p>

                                <hr class="wp-block-separator has-css-opacity is-style-wide">

                                <p><em>This is an amalgamated example from several family enterprise scenarios created to illustrate risk management issues.</em></p>
  
  
                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="podcast"><a href="https://www.thefbcg.com/resource/managing-risk-in-the-family-enterprise-its-more-than-financial/" target="_blank">Managing Risk in the Family Enterprise: It’s More than Financial</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('5.4')">Previous</a>
                                    <a class="next" @click="showTile('5.6')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('5.6')" class="preview" @click="showTile('5.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/bdc.jpg'" alt="Investigate new sources of financing">
                            </div>
                            <div class="description">
                                <strong>Investigate new sources of financing</strong> <!--While family businesses have the unique characteristics of a family, they, like other companies are often in search of financing to propel growth. As a family grows and changes, the family business must also evolve to accommodate changing family dynamics.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.6')" class="item-content">
                            <h1>7 sources of start-up financing</h1>

                            <a href="https://www.bdc.ca/en/articles-tools/start-buy-business/start-business/start-up-financing-sources" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-3-6.2.jpg'" style="max-width: 80%; height: auto;" alt="7 sources of start-up financing"></a>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a href="https://assets.kpmg/content/dam/kpmg/pdf/2014/09/family-business-financing-growth.pdf" target="_blank">Financing Family Business growth through individual investors</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.5')">Previous</a>
                                <a class="next" @click="showTile('5.7')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.7')">
                        <span class="item-number">7</span>
                        <div v-if="!isOpened('5.7')" class="preview" @click="showTile('5.7')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/familybusinessmagazine.jpg'" alt="Do you have a dividend policy? If not, will you create one?">
                            </div>
                            <div class="description">
                                <strong>Do you have a dividend policy? If not, will you create one?</strong> <!--Dividends play an important role in rewarding shareholders, but must be viewed in the broader context of the varying liquidity needs of shareholders and their vision of the company’s future.-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.7')" class="item-content">
                            <h1>Dividend Policy in Perspective</h1>
                            <a href="https://www.familybusinessmagazine.com/dividend-policy-perspective" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-3-6.3.jpg'" style="max-width: 80%; height: auto;" alt=""></a>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://www.familywealthlibrary.com/post/dividends-in-family-business/" target="_blank">How to Effectively Approach Dividends in Family Business</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.6')">Previous</a>
                                <a class="next" @click="showTile('5.8')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.8')">
                        <span class="item-number">8</span>
                        <div v-if="!isOpened('5.8')" class="preview" @click="showTile('5.8')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo149885329.jpg'" alt="Has founder kept enough for retirement">
                            </div>
                            <div class="description">
                                <strong>Has founder kept enough for retirement</strong> <!--When the founder or business owner is so wrapped up in the business that they can't separate their identity from it, they'll likely always find a reason or excuse for not stepping away in a timely, seamless way-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.8')" class="item-content">
                            <h1>What Does Your Retirement Look Like?</h1>

                            <iframe :src="baseurl + 'assets/pdf/ownership/What-Does-Your-Retirement Look-Like.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/What-Does-Your-Retirement Look-Like.pdf'" target="_blank">What Does Your Retirement Look Like? - PDF Template</a></li>
                                    
                                    <li class="video"><a href="https://www.forbes.com/sites/forbescoachescouncil/2019/07/08/the-fourth-commandment-of-family-business-succession-have-a-life-outside-the-business/?sh=720ac98e6291" target="_blank">The Fourth Commandment Of Family Business Succession: Have A Life Outside The Business</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.7')">Previous</a>
                                <a class="next" @click="showTile('5.9')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                
                    <li :class="statusClass('5.9')">
                        <span class="item-number">9</span>
                        <div v-if="!isOpened('5.9')" class="preview" @click="showTile('5.9')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Keep a close eye on the tax landscape">
                            </div>
                            <div class="description">
                                <strong>Keep a close eye on the tax landscape</strong> <!--Getting the right advice on tax and legal strctures is critical during your ownership transition. Read some adviceto follow during this process and keep up to date on any chnages to the national tax and legal landscape-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.9')" class="item-content">
                            <div class="block">

                                <h1>Be Patient! Listen Up! Speak Up!</h1>
                                <div class="res-author">David C. Bentall</div>
                                <div class="res-date">Published: Apr 22, 2021</div>  
    
                                <p>I come from a family with a successful track record of business achievements that span most of the last century. My grandfather, Charles, and my father, Clark both built an enviable track record in the construction and real estate industries. Because of their reputation, integrity and excellence became synonymous with our company name: The Bentall Group.</p>

                                <p>Today, across North America, Europe, and Asia, real estate professionals work under a slightly different name: “BentallGreenOak” However, in some ways, they continue to build on the legacy that our family created. As of December 2020, this company had over $55 billion in assets under management. Sadly, nobody in our family is employed in this enterprise, nor do they share own any shares.</p>

                                <p>How did this happen? There are many theories, but I think three things which contributed to the situation are worth mentioning.</p>

                                <p>First of all, my own impatience and youthful exuberance played a significant part. If I had not been so critical of others and seeking to change everything overnight, the story of our family enterprise might have had a different ending. Unfortunately, as a successor I struggled to submit to organizational authority. This is why I now passionately encourage all “would be” successors to learn from my experience. Be patient! If you are deserving, your chance to lead will likely come.</p>

                                <p>Secondly, my father’s generation focused on “hard issues“ (sales, profits, taxes, etc.). As a result, and as Harvard professor, Bi Barnes, often observed with families in business, our family let the “hard drive out the soft“. In creating our plans and getting technical advice from our professional advisors for our family business, the long term implications and the relational impact of many decisions were not considered. Had we been alert to the need to invest in family communications, as well as appropriate governance structures, we could have been successful in charting a different course.</p>

                                <p>Thirdly, we had good advice. In fact, we had some of the best professional advisors that money could buy, and for the most part, they served us well. However, unfortunately, none of our advisors warned us of the pending relational disaster that lay ahead. Had they spoken up, someone might have been able to prevent the eventual unraveling of our family enterprise.</p>

                                <p>Let me illustrate:</p>

                                <ol>
                                    <li>We had good legal advice. But, our legal advisors did not notice, nor did they speak up about the fact that in our shareholders’ agreement there was no conflict resolution mechanism. Consequently, my father and his brothers found themselves in an argument after working together for 40 years; and when the documents were examined, they found “no way out of the room“. This exasperated matters for the family. Furthermore, no one was realized the dangers of the inherently unstable shareholding structure, which eventually collapsed, bringing an end to the family’s participation in the company.<br></li>
                                    <li>Our tax advice was also excellent. However, no-one discussed the loss of control that could occur as a result of some proposed share transfers. In addition, the estate freeze, which was done many years ago, saved on taxes but also contributed to unintended consequences, when the primary wealth creator in our family faced the humiliation of being cash starved when control of the company slipped into other people’s hands.<br></li>
                                    <li>We also had great corporate management team, and capable business leaders. However, no one in management had the wisdom or courage to speak up, when they might have prevented the cataclysmic explosion which was coming. Certainly they could see the opposing strategic views and life goals of some of the shareholders. Perhaps they could have sounded the alarm sooner?</li>
                                </ol>

                                <p>So, what can be done for other family enterprises who may face challenges like ours in the future?</p>

                                <p><strong>BE PATIENT!</strong> Successors would be wise to be respectful and patient, while waiting for their turn to lead. This would take a lot of stress out of the family system.</p>

                                <p><strong>LISTEN UP!</strong> Business families would do well to request input from their advisors on the non-technical implications of their plans. They may be able to foresee potential problems ahead of time.</p>

                                <p><strong>SPEAK UP!</strong> Professional advisors have a unique perspective. As a result, they should have the courage to speak up when they spot issues which their client families may not be aware of. A word of warning offered by a trusted advisor could make all the difference.</p>

                                <p>These three actions would each have the potential to assist other entrepreneurs and their families to enjoy a better end result than we had in our family. So, if you are a successor, be patient; If you are an owner, listen up; and if you are an advisor, speak up!</p>

                                <p>You owe it to yourself, your family, and your clients.</p>
 
                                <hr class="wp-block-separator is-style-wide">

                                <p class="has-small-font-size"><em>David’s latest book, <strong>Dear Younger Me: Wisdom for Family Enterprise Successors</strong>, has just been released. You can order a signed copy by simply <a href="https://nextstepadvisors.ca/purchase-books/" target="_blank" rel="noreferrer noopener">clicking here</a>.</em></p>
  
  
                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="link"><a href="https://www.cpacanada.ca/en/public-interest/public-policy-government-relations/policy-advocacy/cpa-canada-tax-review-initiative" target="_blank">Canadians deserve a better tax system</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('5.8')">Previous</a>
                                    <a class="next" @click="showTile('5.10')">Next</a>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.10')">
                        <span class="item-number">10</span>
                        <div v-if="!isOpened('5.10')" class="preview" @click="showTile('5.10')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Identify a tax specilist and engage them on key aspect of finanacially transitioning ownership">
                            </div>
                            <div class="description">
                                <strong>Identify a tax specilist and engage them on key aspect of finanacially transitioning ownership</strong> <!--Having a trusted advisor guide you through the tax and legal planning can help save time and a lot of frustration. Explore the incredible Family Enterprise Advisors (FEAs)equipped to help you along this journey-->
                            </div>
                        </div>
                        <div v-if="isOpened('5.10')" class="item-content">

                            <h1>Find a Family Enterprise Advisor (FEA)</h1>

                            <iframe src="https://familyenterprise.ca/fea-directory/?_sft_expertise=tax-planning" class="tut"></iframe>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.9')">Previous</a>
                                <a class="next hide"></a>
                            </div>
                        </div>
                    </li>
                    
                </ul>
            </div>


            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 7 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->
            


        </div>
    </div>
  </div>
</template>

<script>

import threeCircleModel from "@/components/three-circle-model.vue";

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
  name: "camp1-path3",
  components: {
    threeCircleModel,
  },
  data() {
    return {
      tile: 1,
      openedTile: 0,
      completedTiles:  (getCookie("completedTiles3") ? JSON.parse(getCookie("completedTiles3")) : []),
      path: 3,
      progress1: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      progress5: 0,
    };
  },
  props: ["vimeoPause","vimeoPlay","vimeoGoTo","voidPath","step"],
  computed: { },
  methods: {


    statusClass(t) {
        let c = '';

        if (this.isCompleted(t)) {
            c = c + ' done ';
        }
        
        if (this.activeTile(t)) {
            c = c + ' active ';
        }
        
        return c;
    }, 

    getProgress(s) {
        let p = 0;

        switch (s) {
            case 1:
                if (this.completedTiles.includes('1.1')) { p += 20; }
                if (this.completedTiles.includes('1.2')) { p += 20; }
                if (this.completedTiles.includes('1.3')) { p += 20; }
                if (this.completedTiles.includes('1.4')) { p += 20; }
                if (this.completedTiles.includes('1.5')) { p += 20; }
                //if (this.completedTiles.includes('1.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress1 = p;
                break;

            case 2:
                if (this.completedTiles.includes('2.1')) { p += 17; }
                if (this.completedTiles.includes('2.2')) { p += 17; }
                if (this.completedTiles.includes('2.3')) { p += 17; }
                if (this.completedTiles.includes('2.4')) { p += 17; }
                if (this.completedTiles.includes('2.5')) { p += 17; }
                if (this.completedTiles.includes('2.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress2 = p;
                break;

            case 3:
                if (this.completedTiles.includes('3.1')) { p += 33.5; }
                if (this.completedTiles.includes('3.2')) { p += 33.5; }
                if (this.completedTiles.includes('3.3')) { p += 33.5; }
                // if (this.completedTiles.includes('3.4')) { p += 17; }
                // if (this.completedTiles.includes('3.5')) { p += 17; }
                // if (this.completedTiles.includes('3.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress3 = p;
                break;

            case 4:
                if (this.completedTiles.includes('4.1')) { p += 20; }
                if (this.completedTiles.includes('4.2')) { p += 20; }
                if (this.completedTiles.includes('4.3')) { p += 20; }
                if (this.completedTiles.includes('4.4')) { p += 20; }
                if (this.completedTiles.includes('4.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress4 = p;
                break;

            case 5:
                if (this.completedTiles.includes('5.1')) { p += 10; }
                if (this.completedTiles.includes('5.2')) { p += 10; }
                if (this.completedTiles.includes('5.3')) { p += 10; }
                if (this.completedTiles.includes('5.4')) { p += 10; }
                if (this.completedTiles.includes('5.5')) { p += 10; }
                if (this.completedTiles.includes('5.6')) { p += 10; }
                if (this.completedTiles.includes('5.7')) { p += 10; }
                if (this.completedTiles.includes('5.8')) { p += 10; }
                if (this.completedTiles.includes('5.9')) { p += 10; }
                if (this.completedTiles.includes('5.10')) { p += 10; }
                if (p > 100) { p = 100; }
                this.progress5 = p;
                break;
        }

        return '';
    },

    goto(s) {
        this.step = s;
        this.vimeoGoTo(1, 3, s);
    },

    nextStep() {
        this.step = this.step + 1;
        this.vimeoGoTo(1, 3, this.step);
    },

    previousStep() {
        this.step = this.step - 1;
        this.vimeoGoTo(1, 3, this.step);
    },
    

    activeTile(t) {
        if (this.tile == t) {
            return true;
        }
        return false;
    },

    showTile(t) {
        
        if (this.openedTile) {
            this.closeTile()
        }

        this.tile = t;
        this.openedTile = t;
    },

    closeTile() {
        this.completed(this.openedTile);
        this.openedTile = 0;
        this.tile = 0;
    },

    isOpened(t) {
        if (this.openedTile == t) {
            return true;
        }
        return false;
    },

    completed(t) {

        if (!this.completedTiles.includes(t)) {
            this.completedTiles.push(t);
        }
        setCookie("completedTiles3", JSON.stringify(this.completedTiles));

        for (var i = 1; i < 6; i++) {
            this.getProgress(i);
        }
    },

    isCompleted(t) {

        if (this.completedTiles.includes(t)) {
            return true;
        }
        return false;
    }
  }
};
</script>

<style scoped>


</style>
